/**
 * Utility functions for pregnancy/breastfeeding page handling
 * 
 * Known Issue: Browser back button and breadcrumb navigation on pregnancy/breastfeeding pages
 * sometimes gets stuck in a navigation loop. This appears to be related to how the Redux state
 * manages "active" classes in the map for quicklinks pages. Other guideline pages work correctly.
 * The issue is specific to pages with guidelinePage=quicklinks and topicfile=pbf.
 */

const getPageParams = (searchParams, pathname) => {
  if (!pathname.includes('/viewTopic')) {
    return null;
  }
  
  return {
    guidelinePage: searchParams?.get?.('guidelinePage'),
    etgAccess: searchParams?.get?.('etgAccess'),
    sectionId: searchParams?.get?.('sectionId'),
    topicfile: searchParams?.get?.('topicfile'),
  };
};

const hasBasePregnancyConditions = (params) => {
  return params && 
    params.guidelinePage === 'quicklinks' && 
    params.etgAccess === 'true';
};

export const isPregnancyBreastfeedingPage = (searchParams, pathname) => {
  const params = getPageParams(searchParams, pathname);
  
  return hasBasePregnancyConditions(params) && (
    params.topicfile === 'pbf' || 
    (params.sectionId && params.sectionId.includes('Drugs_and_their_categories_in_pregnancy_and_breastfeeding'))
  );
};

export const isPregnancyBreastfeedingIndex = (searchParams, pathname) => {
  const params = getPageParams(searchParams, pathname);
  
  // Only apply to the specific drug categories index pages with collapsible tables
  return hasBasePregnancyConditions(params) && 
    params.topicfile === 'pbf' &&
    params.sectionId && 
    params.sectionId.includes('Drugs_and_their_categories_in_pregnancy_and_breastfeeding');
};

export const useIsPregnancyBreastfeedingPage = (search, pathname) => {
  const searchParams = new URLSearchParams(search);
  return isPregnancyBreastfeedingPage(searchParams, pathname);
};

export const useIsPregnancyBreastfeedingIndex = (search, pathname) => {
  const searchParams = new URLSearchParams(search);
  return isPregnancyBreastfeedingIndex(searchParams, pathname);
};